module.exports = __webpack_public_path__ + "img/Unlocking_the_Potential_of_Engineering_Teams.b3b5ee3f.jpeg";